import { BreakpointObserver, BreakpointState } from '@angular/cdk/layout';
import {
  Component,
  EventEmitter,
  OnInit,
  Output,
  ViewChild,
} from '@angular/core';
import { MatAccordion } from '@angular/material/expansion';
import { MatSidenav } from '@angular/material/sidenav';
import { first, Observable } from 'rxjs';
import { LoadingService } from '../../services/loading.service';
import { Router } from '@angular/router';
import { roles } from '../../../shared/constants/user-roles.constants';
import { TerminalsService } from '../../../operation/terminals/services/terminals.service';
import { UserAuthService } from '../../../shared/services/user-auth.service';
import { SharedService } from '../../../shared/services/shared.service';

const SMALL_WIDTH_BREAKPOINT = 720;

@Component({
  selector: 'app-sidenav',
  standalone: false,
  templateUrl: './sidenav.component.html',
  styleUrl: './sidenav.component.scss',
})
export class SidenavComponent implements OnInit {
  @Output() toggleSidenav = new EventEmitter<void>();
  @ViewChild(MatAccordion) accordion!: MatAccordion;
  @ViewChild(MatSidenav) sidenav!: MatSidenav;

  authorizedRoles: any;
  authorizedReleaseManagerRoles: any;
  authorizedRolesLocations: any;
  authorizedRolesCompliance: any;
  authorizedRolesOnboarding: any;
  public isScreenSmall: boolean = false;
  isLoading!: Observable<boolean>;
  userRoles: any;
  displayStyle = 'block';
  siteAdminOnly: any;
  isOperator!: Observable<boolean>;

  constructor(
    private breakpointObserver: BreakpointObserver,
    private router: Router,
    private loadingService: LoadingService,
    private terminalService: TerminalsService,
    private authService: UserAuthService,
    private sharedService: SharedService,
  ) {
    this.isLoading = this.loadingService.isLoading$;
    this.isOperator = this.sharedService.showOperatorPage$;
  }

  clickedItem: any;

  ngOnInit(): void {
    this.isOperator.subscribe({
      next: (data) => this.callCache(data),
      error: () => console.log('Error loading roles!'),
    });
    this.authService
      .getUserRoles()
      .pipe(first())
      .subscribe({
        next: (data) => ((this.userRoles = data.roles), this.setRoles(data)),
        error: () => console.log('Error loading roles!'),
      });
    this.breakpointObserver
      .observe([`(max-width: ${SMALL_WIDTH_BREAKPOINT}px)`])
      .subscribe((state: BreakpointState) => {
        this.isScreenSmall = state.matches;
      });

    this.router.events.subscribe(() => {
      if (this.isScreenSmall) {
        this.sidenav.close();
      }
    });

    this.authorizedRoles = [
      roles.SITE_ADMIN,
      roles.CUSTOMER_SUPPORT_ADMIN,
      roles.ADMIN,
    ];
    this.authorizedReleaseManagerRoles = [
      roles.SITE_ADMIN,
      roles.RELEASE_MANAGER,
    ];
    this.authorizedRolesLocations = [
      roles.SITE_ADMIN,
      roles.CUSTOMER_SUPPORT_ADMIN,
      roles.ADMIN,
      roles.CUSTOMER_SUPPORT,
      roles.ACCOUNTING,
    ];

    this.authorizedRolesCompliance = [roles.COMPLIANCE];
    this.authorizedRolesOnboarding = [roles.COMPLIANCE, roles.ADMIN, roles.LEGAL];

    this.siteAdminOnly = [roles.SITE_ADMIN];
    this.isOperator = this.sharedService.showOperatorPage;
  }

  callCache(data: any) {
    if (data) {
      this.sharedService.hideSidebar = true;
    } else {
      this.sharedService.hideSidebar = false;
    }
  }

  setRoles(data: any) {
    this.authService.setUser(data);
  }

  logout() { }

  goToRoute(route: string) {
    this.clickedItem = route;

    if (route !== '/terminals') {
      this.terminalService.clearTerminalSearch();
    }
    this.router.navigate([route]);
  }
}
